import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Output, EventEmitter, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-search-location',
  templateUrl: './search-location.component.html',
  styleUrls: ['./search-location.component.css'],
})
export class SearchLocationComponent implements OnInit, OnChanges {
  @Input() latitude: number | null = null;
  @Input() longitude: number | null = null;
  map: google.maps.Map | undefined;
  marker: google.maps.Marker | any;
  showSearchInput = false;

  @Output() contentChange: EventEmitter<google.maps.places.PlaceResult> =
    new EventEmitter<google.maps.places.PlaceResult>();

  ngOnChanges(changes: SimpleChanges): void {
    console.log('ngOnChanges called => ', changes);
    if (changes['latitude'] || changes['longitude']) {

      console.log('this.latitude, this.longitude', this.latitude, this.longitude);

      if(this.latitude && this.longitude) {
        this?.updateMap();
      }
      
    }
  }

  ngOnInit(): void {
    this.loadGoogleMapsScript().then(() => {
      this.loadMap();
    });
  }

  loadGoogleMapsScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (typeof google !== 'undefined') {
        resolve(); // Google Maps already loaded
      } else {
        const script = document.createElement('script');
        script.src =
          'https://maps.googleapis.com/maps/api/js?key=AIzaSyA9Xi-EcZj4TrvdVQSvpheBXdKldXQhRZU&libraries=places';
        // script.src =
        //   'https://maps.googleapis.com/maps/api/js?key=AIzaSyAe-9yoGZ7zSk6GtvmyHxQeUOLsdJhu760&libraries=places';
        script.onload = () => resolve();
        script.onerror = (err) => reject(err);
        document.body.appendChild(script);
      }
    });
  }

  loadMap() {
    const mapOptions: google.maps.MapOptions = {
      center: { lat: 40.7128, lng: -74.006 }, // Default center (New York)
      zoom: 10,
    };

    this.map = new google.maps.Map(
      document.getElementById('map') as HTMLElement,
      mapOptions
    );

    // // Create a marker (but don't set its position yet)
    // let marker = new google.maps.Marker({
    //   map: this.map,
    // });
    // Initialize the marker (but don't set its position yet)
    this.marker = new google.maps.Marker({
      map: this.map,
      visible: false, // Make the marker invisible initially
    });

    // Add search box functionality
    const input = document.getElementById('searchInput') as HTMLInputElement;
    const searchBox = new google.maps.places.SearchBox(input);

    this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

    // Listen for the search box place changes
    searchBox.addListener('places_changed', () => {
      const places: google.maps.places.PlaceResult[] | undefined =
        searchBox.getPlaces();

      if (places === undefined || places?.length === 0) return;

      // Get the first result's location
      const place = places[0];
      if (!place.geometry || !place.geometry.location) return;

      // Center the map on the searched location
      this.map?.setCenter(place.geometry.location);
      this.map?.setZoom(15);

      // Set marker position on the map at the searched location
      this.marker.setPosition(place.geometry.location);
      this.marker.setVisible(true); // Make sure the marker is visible

      // Capture latitude and longitude
      this.latitude = place.geometry.location.lat();
      this.longitude = place.geometry.location.lng();
      this.contentChange.emit(place);
    });

    // Add a click event listener to the map
    this.map.addListener('click', (event: google.maps.MapMouseEvent) => {
      const clickedLatLng: any = event.latLng;
      if (clickedLatLng) {
        

        // Set the latitude and longitude on click
        this.latitude = clickedLatLng.lat();
        this.longitude = clickedLatLng.lng();
        // Update the marker's position
        this.marker.setPosition(clickedLatLng);
        this.marker.setVisible(true); // Make sure the marker is visible
        console.log('The latitude is:', clickedLatLng, this.latitude, this.longitude);
        this.contentChange.emit(clickedLatLng);
      }
    });

    // setTimeout(() => {
    this.showSearchInput = true;
    // }, 4000);
  }
  updateMap() {
    console.log('The update map function get called', this?.latitude, this?.longitude);
    if (this?.latitude !== null && this?.longitude !== null) {
      const position = new google.maps.LatLng(this.latitude, this.longitude);

      // Center the map on the manually entered position
      this.map?.setCenter(position);
      this.map?.setZoom(15);

      // Set the marker at the manually entered position
      this.marker?.setPosition(position);
      this.marker?.setVisible(true);
    }
  }
}
